import { createContext, useContext } from 'react'

export type PwaInstallContextValue = {
    available: boolean
    supportPwa: boolean
    promptInstall: () => Promise<string | null> | null
    focusInstalledApp?: () => Promise<boolean>
    hide: () => void
    isInstallModalOpen: boolean
    openInstallModal: () => void
    closeInstallModal: () => void
}

export const Context = createContext<PwaInstallContextValue | undefined>(undefined)

export function usePwaContext() {
    const ctx = useContext(Context)
    if (!ctx)
        return {
            available: false,
            supportPwa: false,
            promptInstall: async () => null,
            focusInstalledApp: async () => false,
            hide: () => {},
            isInstallModalOpen: false,
            openInstallModal: () => {},
            closeInstallModal: () => {},
        }
    return ctx
}

export default Context
